;(function( window, document, bq ){ window.jQuery(function($) { 'use strict';

bq.productRelations = function(element, options) {
    this.$el      = $(element);
    this.options  = $.extend({}, bq.productRelations.DEFAULTS, this.$el.data(), options);
    this._loadTimeout  = null;
    this._isLoading    = false;
    this._isManualReload = false;
    this._observer     = null;
    this.init();
};

bq.productRelations.DEFAULTS = {
    queryRelationsUrl:     '',
    supplierImageBaseUrl:  '',
    labels: {
        loadingRelations:  'Loading relations...',
        loadFailed:        'Failed to load relations.',
        errorLoading:      'Error loading relations.',
        noRelations:       'No relations found.',
        recommend:         'Recommend',
        createRelation:    'Create Relation',
        deleteRelation:    'Delete Relation',
        setCaseSizing:     'Set Units Per SKU',
        productNotFound:   'Product not found',
        image:             'Image',
        productName:       'Product Name',
        supplier:          'Supplier',
        sku:               'SKU',
        unitsPerSku:       'Units Per SKU',
        actions:           'Actions',
        deleteRelationLink:'Delete Relation',
        setCaseSizingLink: 'Set Units Per SKU',
        focus:             'Focus',
        recommendLink:     'Recommend',
        createRelationLink:'Create Relation'
    }
};

bq.productRelations.prototype = {
    init: function() {
        this._setupWatcher();
        this._bindEvents();
        this._loadRelations();
    },

    _id: function() {
        return this.$el.attr('id') || 'bqRelations';
    },

    _currentProduct: function() {
        return {
            productId:  this.$el.attr('data-product-id')  || '',
            supplierId: this.$el.attr('data-supplier-id') || '',
            sku:        this.$el.attr('data-sku')         || ''
        };
    },

    _loadRelations: function() {
        var self    = this;
        var id      = this._id();
        var product = this._currentProduct();

        if (this._loadTimeout) { clearTimeout(this._loadTimeout); this._loadTimeout = null; }
        if (this._isLoading) {
            this._loadTimeout = setTimeout(function() { self._loadRelations(); }, 500);
            return;
        }

        var $loading = $('#' + id + '-loading');
        var $error   = $('#' + id + '-error');
        var $content = $('#' + id + '-content');
        var show = function($el, cls) { $el.addClass(cls + '--visible'); };
        var hide = function($el, cls) { $el.removeClass(cls + '--visible'); };

        if (!product.productId && (!product.supplierId || !product.sku)) {
            hide($loading, 'bq-relations-container__loading');
            hide($error,   'bq-relations-container__error');
            hide($content, 'bq-relations-container__content');
            return;
        }

        this._isLoading = true;
        this.$el.css({ 'pointer-events': 'none', opacity: '0.6' });
        show($loading, 'bq-relations-container__loading');
        hide($error,   'bq-relations-container__error');
        hide($content, 'bq-relations-container__content');

        var requestData = {};
        if (product.productId)  { requestData.product_id  = product.productId; }
        if (product.supplierId) { requestData.supplier_id = product.supplierId; }
        if (product.sku)        { requestData.sku         = product.sku; }

        $.ajax({
            url:         this.options.queryRelationsUrl,
            type:        'POST',
            contentType: 'application/json',
            dataType:    'json',
            data:        JSON.stringify(requestData)
        }).done(function(resp) {
            hide($loading, 'bq-relations-container__loading');
            self.$el.css({ 'pointer-events': '', opacity: '' });
            self._isLoading = false;

            if (!resp || resp.success === false) {
                $error.text(bq.messages.recommendations.loadRelationsFailed);
                show($error, 'bq-relations-container__error');
                return;
            }

            var fromRelations = resp.from_relations || [];
            var toRelations   = resp.to_relations   || [];
            var current       = resp.current_relation || {};

            if (!current) { current = {}; }
            if (!current.product_id  && product.productId)  { current.product_id  = product.productId; }
            if (!current.supplier_id && product.supplierId) { current.supplier_id = product.supplierId; }
            if (!current.supplier_sku && product.sku)       { current.supplier_sku = product.sku; }
            current.status = 'CURRENT';

            $.each(fromRelations, function(_, i) { i.status = 'FROM'; });
            $.each(toRelations,   function(_, i) { i.status = 'TO'; });

            self._renderFlexContainer($('#' + id + '-from-container'),    fromRelations);
            self._renderFlexContainer($('#' + id + '-current-container'), [current]);
            self._renderFlexContainer($('#' + id + '-to-container'),      toRelations);

            show($content, 'bq-relations-container__content');
        }).fail(function(xhr) {
            self.$el.css({ 'pointer-events': '', opacity: '' });
            hide($loading, 'bq-relations-container__loading');
            self._isLoading = false;
            var msg = bq.messages.recommendations.errorLoading;
            if (xhr.responseJSON && xhr.responseJSON.error) { msg = xhr.responseJSON.error; }
            $error.text(msg);
            show($error, 'bq-relations-container__error');
        });
    },

    _esc: function(s) { return $('<div>').text(s || '').html(); },

    _renderFlexContainer: function($container, items) {
        var self   = this;
        var labels = bq.messages.recommendations;
        $container.empty().removeClass('empty-state');

        if (!items || !items.length) {
            $container.addClass('empty-state').append('<div class="relations-no-data">' + labels.noRelations + '</div>');
            return;
        }

        var headerHtml =
            '<div class="relations-flex-header">' +
            '<div class="relations-flex-col relations-flex-col-image">'      + labels.image      + '</div>' +
            '<div class="relations-flex-col relations-flex-col-name">'       + labels.productName + '</div>' +
            '<div class="relations-flex-col relations-flex-col-supplier">'   + labels.supplier   + '</div>' +
            '<div class="relations-flex-col relations-flex-col-sku">'        + labels.sku        + '</div>' +
            '<div class="relations-flex-col relations-flex-col-multiplier">' + labels.unitsPerSku + '</div>' +
            '<div class="relations-flex-col relations-flex-col-actions">'    + labels.actions    + '</div>' +
            '</div>';
        $container.append(headerHtml);

        $.each(items, function(_, item) {
            var supplierImageBaseUrl    = self.options.supplierImageBaseUrl;
            var defaultSupplierImageUrl = supplierImageBaseUrl ? (supplierImageBaseUrl + 'placeholder.jpg') : '';
            var parsedSupplierId        = parseInt(item.supplier_id, 10);
            var supplierFallback        = (parsedSupplierId && supplierImageBaseUrl)
                ? (supplierImageBaseUrl + parsedSupplierId + '.jpg')
                : defaultSupplierImageUrl;
            var resolvedImageUrl = item.image ? String(item.image) : supplierFallback;
            var esc = bq.recommendations.escapeHtmlAttr;
            var imageHtml = resolvedImageUrl
                ? ('<img src="' + esc(resolvedImageUrl) + '" alt="" class="rec-relations-img"' +
                    ' data-fallback-state="primary"' +
                    ' data-supplier-fallback="' + esc(supplierFallback) + '"' +
                    ' data-default-fallback="' + esc(defaultSupplierImageUrl) + '"' +
                    ' onerror="bqHandleRecommendationImageError(this)" />')
                : '<div class="rec-relations-img-placeholder"></div>';

            var productName = item.name || '';
            var nameDisplay;
            var nameTitle = productName ? self._esc(productName) : '';
            if (productName && item.url) {
                nameDisplay = '<a href="' + self._esc(item.url) + '" target="_blank" rel="noopener noreferrer" title="' + nameTitle + '" class="rec-text-truncate">' + nameTitle + '</a>';
            } else if (productName) {
                nameDisplay = '<span title="' + nameTitle + '" class="rec-text-truncate">' + nameTitle + '</span>';
            } else if (item.found === false || (!item.product_id && item.supplier_id && (item.supplier_sku || item.sku))) {
                nameDisplay = '<span class="rec-text-muted-italic">' + labels.productNotFound + '</span>';
            } else {
                nameDisplay = '<span class="rec-text-muted">-</span>';
            }

            var supplierValue = item.supplier_name || item.supplier_id || '';
            var supplierDisplay = supplierValue
                ? '<span title="' + self._esc(supplierValue) + '" class="rec-text-truncate">' + self._esc(supplierValue) + '</span>'
                : '<span class="rec-text-muted">-</span>';

            var skuValue = item.supplier_sku || item.sku || '';
            var skuDisplay = skuValue
                ? '<span title="' + self._esc(skuValue) + '" class="rec-text-truncate">' + self._esc(skuValue) + '</span>'
                : '<span class="rec-text-muted">-</span>';

            var caseSizingDisplay;
            if (item.units_per_sku !== null && item.units_per_sku !== undefined && item.units_per_sku !== '') {
                var v = parseFloat(item.units_per_sku);
                caseSizingDisplay = isNaN(v)
                    ? '<span class="rec-text-muted">-</span>'
                    : (v % 1 === 0 ? v.toString() : v.toFixed(2).replace(/\.?0+$/, ''));
            } else {
                caseSizingDisplay = '<span class="rec-text-muted">-</span>';
            }

            var externalIdVal = item.external_id !== undefined ? item.external_id : (item.ExternalID !== undefined ? item.ExternalID : null);
            var externalId = (externalIdVal !== null && externalIdVal !== undefined && externalIdVal !== '') ? String(externalIdVal) : '';

            var d = function(v) { return self._esc(v || ''); };

            var deleteLink = '';
            if (externalId && item.status && item.status !== 'CURRENT') {
                deleteLink = '<li><a href="javascript:void(0);" class="relations-action-delete-relation"' +
                    ' data-product-id="' + d(item.product_id) + '"' +
                    ' data-supplier-id="' + d(item.supplier_id) + '"' +
                    ' data-sku="' + d(skuValue) + '"' +
                    ' data-external-id="' + d(externalId) + '">' + labels.deleteRelationLink + '</a></li>';
            }

            var setCaseSizingLink = '<li><a href="javascript:void(0);" class="relations-action-case-sizing"' +
                ' data-product-id="' + d(item.product_id) + '"' +
                ' data-supplier-id="' + d(item.supplier_id) + '"' +
                ' data-sku="' + d(skuValue) + '"' +
                ' data-external-id="' + d(item.external_id || '') + '">' + labels.setCaseSizingLink + '</a></li>';

            var focusLink = '';
            if (item.status !== 'CURRENT' && item.product_id) {
                focusLink = '<li><a href="javascript:void(0);" class="relations-action-focus"' +
                    ' data-product-id="' + d(item.product_id) + '"' +
                    ' data-supplier-id="' + d(item.supplier_id) + '"' +
                    ' data-sku="' + d(skuValue) + '">' + labels.focus + '</a></li>';
            }

            var actionsHtml =
                '<div class="bq-relations-dropdown-wrapper">' +
                '<button class="bq-relations-dropdown-btn btn btn-default" type="button" aria-label="menu"><span class="fa fa-ellipsis-h"></span></button>' +
                '<ul class="bq-relations-dropdown-menu">' +
                '<li><a href="javascript:void(0);" class="relations-action-recommend"' +
                ' data-product-id="' + d(item.product_id) + '"' +
                ' data-supplier-id="' + d(item.supplier_id) + '"' +
                ' data-sku="' + d(skuValue) + '">' + labels.recommendLink + '</a></li>' +
                '<li><a href="javascript:void(0);" class="relations-action-create-relation"' +
                ' data-product-id="' + d(item.product_id) + '"' +
                ' data-supplier-id="' + d(item.supplier_id) + '"' +
                ' data-sku="' + d(skuValue) + '">' + labels.createRelationLink + '</a></li>' +
                deleteLink + focusLink + setCaseSizingLink +
                '</ul>' +
                '</div>';

            $container.append(
                '<div class="relations-flex-item">' +
                '<div class="relations-flex-col relations-flex-col-image">'      + imageHtml      + '</div>' +
                '<div class="relations-flex-col relations-flex-col-name">'       + nameDisplay    + '</div>' +
                '<div class="relations-flex-col relations-flex-col-supplier">'   + supplierDisplay + '</div>' +
                '<div class="relations-flex-col relations-flex-col-sku">'        + skuDisplay     + '</div>' +
                '<div class="relations-flex-col relations-flex-col-multiplier">' + caseSizingDisplay + '</div>' +
                '<div class="relations-flex-col relations-flex-col-actions">'    + actionsHtml    + '</div>' +
                '</div>'
            );
        });

        this._initCustomDropdowns($container);
        this._bindRelationsActions($container);
    },

    _initCustomDropdowns: function($container) {
        $container.find('.bq-relations-dropdown-btn').off('click.relationsDropdown').on('click.relationsDropdown', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var $menu = $(this).closest('.bq-relations-dropdown-wrapper').find('.bq-relations-dropdown-menu');
            $('.bq-relations-dropdown-menu').not($menu).hide();
            $menu.toggle();
        });
    },

    _isNewDesign: function() {
        return typeof bq.getIsThemeNew === 'function'
            ? bq.getIsThemeNew()
            : $('body').is('.theme-new, .light-theme, .dark-theme');
    },

    _closeDropdownMenu: function($trigger) {
        if (!this._isNewDesign()) {
            return;
        }

        $trigger.closest('.bq-relations-dropdown-wrapper').find('.bq-relations-dropdown-menu').hide();
    },

    _bindRelationsActions: function($container) {
        var self = this;

        $container.find('.relations-action-recommend').off('click').on('click', function(e) {
            e.preventDefault();
            var $a = $(this);
            self._closeDropdownMenu($a);
            var $row = $a.closest('.relations-flex-item');
            var $nameCol = $row.find('.relations-flex-col-name');
            var $imageCol = $row.find('.relations-flex-col-image');
            self._openRelationsModal('recommend', $a.data('supplier-id'), $a.data('sku'), {
                product_id: $a.data('product-id'),
                name:  ($nameCol.find('a').length ? $nameCol.find('a').text() : $nameCol.text()).trim() || null,
                image: $imageCol.find('img').attr('src') || null
            });
        });

        $container.find('.relations-action-create-relation').off('click').on('click', function(e) {
            e.preventDefault();
            var $a = $(this);
            self._closeDropdownMenu($a);
            self._openRelationsModal('create-relation', $a.data('supplier-id'), $a.data('sku'), { product_id: $a.data('product-id') });
        });

        $container.find('.relations-action-delete-relation').off('click').on('click', function(e) {
            e.preventDefault();
            var $a = $(this);
            self._closeDropdownMenu($a);
            var $row = $a.closest('.relations-flex-item');
            var $nameCol = $row.find('.relations-flex-col-name');
            self._openRelationsModal('delete-relation', $a.data('supplier-id'), $a.data('sku'), {
                product_id:  $a.data('product-id'),
                external_id: $a.attr('data-external-id') || $a.data('external-id') || null,
                name: ($nameCol.find('a').length ? $nameCol.find('a').text() : $nameCol.text()).trim() || null
            });
        });

        $container.find('.relations-action-case-sizing').off('click').on('click', function(e) {
            e.preventDefault();
            var $a = $(this);
            self._closeDropdownMenu($a);
            var $row = $a.closest('.relations-flex-item');
            var $nameCol       = $row.find('.relations-flex-col-name');
            var $imageCol      = $row.find('.relations-flex-col-image');
            var $multiplierCol = $row.find('.relations-flex-col-multiplier');
            var multiplierText = $multiplierCol.text().trim();
            var unitsPerSku    = null;
            if (multiplierText && multiplierText !== '-') {
                var parsed = parseFloat(multiplierText);
                if (!isNaN(parsed)) { unitsPerSku = parsed; }
            }
            self._openRelationsModal('case-sizing', $a.data('supplier-id'), $a.data('sku'), {
                product_id:  $a.data('product-id'),
                external_id: $a.attr('data-external-id') || $a.data('external-id') || null,
                name:        ($nameCol.find('a').length ? $nameCol.find('a').text() : $nameCol.text()).trim() || null,
                image:       $imageCol.find('img').attr('src') || null,
                units_per_sku: unitsPerSku
            });
        });

        $container.find('.relations-action-focus').off('click').on('click', function(e) {
            e.preventDefault();
            var $a = $(this);
            self._closeDropdownMenu($a);
            self.$el
                .attr('data-supplier-id', $a.data('supplier-id'))
                .attr('data-sku', $a.data('sku'));
            if ($a.data('product-id')) { self.$el.attr('data-product-id', $a.data('product-id')); }
        });
    },

    _modalHtml: function(action) {
        var htmlMap = window.bqRelationsModalHtml || {};
        if (action === 'recommend')      { return htmlMap.recommend      || ''; }
        if (action === 'create-relation'){ return htmlMap.createRelation || ''; }
        if (action === 'case-sizing')    { return htmlMap.caseSizing     || ''; }
        if (action === 'delete-relation'){ return htmlMap.deleteRelation || ''; }
        return '';
    },

    _modalTitle: function(action) {
        var labels = bq.messages.recommendations;
        if (action === 'recommend')       { return labels.recommend; }
        if (action === 'create-relation') { return labels.createRelation; }
        if (action === 'delete-relation') { return labels.deleteRelation; }
        if (action === 'case-sizing')     { return labels.setCaseSizing; }
        return action;
    },

    _triggerFormEvent: function(action, modalId, supplierId, sku, itemData) {
        var eventMap = {
            'recommend':       'recommendFormInserted',
            'create-relation': 'createRelationFormInserted',
            'case-sizing':     'quantityMultiplierFormInserted',
            'delete-relation': 'deleteRelationFormInserted'
        };
        var formClassMap = {
            'recommend':       '.recommend-product-form-content',
            'create-relation': '.create-relation-form-content',
            'case-sizing':     '.quantity-multiplier-form-content',
            'delete-relation': '.delete-relation-form-content'
        };
        var eventName = eventMap[action];
        var formClass = formClassMap[action];
        if (!eventName) { return; }

        setTimeout(function() {
            var $modal = (typeof bq !== 'undefined' && bq.helper && bq.helper.modal && bq.helper.modal.modals)
                ? (bq.helper.modal.modals[modalId] || $('#' + modalId))
                : $('#' + modalId);
            if ($modal && $modal.length) {
                var $fc = $modal.find(formClass);
                if ($fc.length) {
                    $fc.attr('data-supplier-id', supplierId).attr('data-sku', sku);
                    if (action === 'delete-relation' || action === 'case-sizing') {
                        $fc.attr('data-external-id', itemData.external_id || '');
                    }
                    var bqAttr = $fc.attr('data-bq');
                    if (bqAttr && typeof bq !== 'undefined') {
                        var initFnName = bqAttr.replace(/-([a-z])/g, function(_, c) { return c.toUpperCase(); }) + 'Init';
                        if (typeof bq[initFnName] === 'function') { bq[initFnName](); }
                    }
                }
            }
            $(document).trigger(eventName);
        }, 100);
    },

    _openRelationsModal: function(action, supplierId, sku, itemData) {
        itemData = itemData || {};
        var modalId = 'relations-modal-' + action;
        var title   = this._modalTitle(action);
        var content = this._modalHtml(action);
        var self    = this;

        if (action === 'recommend')       { window.bqOpenRecommendFor       = { product_id: itemData.product_id || null, supplier_id: supplierId, sku: sku, name: itemData.name || null, image: itemData.image || null }; }
        if (action === 'create-relation') { window.bqOpenCreateRelationFor  = { product_id: itemData.product_id || null, supplier_id: supplierId, sku: sku }; }
        if (action === 'case-sizing')     { window.bqOpenCaseSizingFor      = { product_id: itemData.product_id || null, supplier_id: supplierId, sku: sku, name: itemData.name || null, image: itemData.image || null, case_sizing: itemData.units_per_sku !== undefined ? itemData.units_per_sku : null, external_id: itemData.external_id || null }; }
        if (action === 'delete-relation') { window.bqOpenDeleteRelationFor  = { product_id: itemData.product_id || null, supplier_id: supplierId, sku: sku, external_id: itemData.external_id || null, name: itemData.name || null }; }

        var hasBqHelper = typeof bq !== 'undefined' && bq.helper && bq.helper.modal;

        if (hasBqHelper) {
            if (bq.helper.modal.modals[modalId]) {
                var $existingModal = bq.helper.modal.modals[modalId];
                $existingModal.find('.modal-title').html(title);
                var $body = $existingModal.find('.modal-body');
                if ($body.length) { $body.html(content); } else { $existingModal.find('.modal-content').append('<div class="modal-body">' + content + '</div>'); }
                self._triggerFormEvent(action, modalId, supplierId, sku, itemData);
                $existingModal.modal({ backdrop: true, show: true });
            } else {
                bq.helper.modal.create(modalId, null, title, content, false, { '.modal-dialog': 'modal-lg' });
                self._triggerFormEvent(action, modalId, supplierId, sku, itemData);
            }
        } else {
            var $existing = $('#' + modalId);
            if ($existing.length) {
                $existing.find('.modal-title').html(title);
                var $mb = $existing.find('.modal-body');
                if ($mb.length) { $mb.html(content); } else { $existing.find('.modal-content').append('<div class="modal-body">' + content + '</div>'); }
                self._triggerFormEvent(action, modalId, supplierId, sku, itemData);
                $existing.modal({ backdrop: true, show: true });
            } else {
                $('body').append(
                    '<div class="modal fade" id="' + modalId + '" tabindex="-1" role="dialog" aria-hidden="true">' +
                    '<div class="modal-dialog modal-lg"><div class="modal-content">' +
                    '<div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button>' +
                    '<div class="h4 modal-title">' + title + '</div></div>' +
                    '<div class="modal-body">' + content + '</div>' +
                    '</div></div></div>'
                );
                self._triggerFormEvent(action, modalId, supplierId, sku, itemData);
                $('#' + modalId).modal({ backdrop: true, show: true });
            }
        }
    },

    _setupWatcher: function() {
        var self      = this;
        var container = this.$el[0];
        if (!container) { return; }
        if (this._observer) { this._observer.disconnect(); }

        this._observer = new MutationObserver(function(mutations) {
            if (self._isManualReload) { return; }
            var shouldReload = false;
            mutations.forEach(function(m) {
                if (m.type === 'attributes' && (m.attributeName === 'data-supplier-id' || m.attributeName === 'data-sku')) {
                    shouldReload = true;
                }
            });
            if (shouldReload) { self._loadRelations(); }
        });

        this._observer.observe(container, { attributes: true, attributeFilter: ['data-supplier-id', 'data-sku'] });
    },

    _bindEvents: function() {
        var self = this;

        $(document).off('click.relationsDropdown').on('click.relationsDropdown', function(e) {
            if (!$(e.target).closest('.bq-relations-dropdown-wrapper').length) {
                $('.bq-relations-dropdown-menu').hide();
            }
        });

        $(document).off('bqRelationCreated.productRelations').on('bqRelationCreated.productRelations', function() {
            self._isManualReload = true;
            self._loadRelations();
            setTimeout(function() { self._isManualReload = false; }, 1000);
        });

        $(document).off('bqRelationDeleted.productRelations').on('bqRelationDeleted.productRelations', function() {
            self._isManualReload = true;
            self._loadRelations();
            setTimeout(function() { self._isManualReload = false; }, 1000);
        });

        $(document).off('bqQuantityMultiplierSaved.productRelations').on('bqQuantityMultiplierSaved.productRelations', function() {
            self._isManualReload = true;
            self._loadRelations();
            setTimeout(function() { self._isManualReload = false; }, 1000);
        });
    }
};

var old = $.fn.productRelations;
$.fn.productRelations = function(option) {
    return this.each(function() {
        var $this   = $(this);
        var data    = $this.data('bq.productRelations');
        var options = typeof option === 'object' && option;
        if (!data) { $this.data('bq.productRelations', new bq.productRelations(this, options)); }
    });
};
$.fn.productRelations.Constructor = bq.productRelations;
$.fn.productRelations.noConflict  = function() { $.fn.productRelations = old; return this; };

bq.productRelationsInit = function() {
    $('[data-bq="product-relations"]').each(function() {
        var $el = $(this);
        if (!$el.data('bq.productRelations')) { $el.productRelations(); }
    });
};
bq.init.push(bq.productRelationsInit);
bq.productRelationsInit();

});}( window, document, bq));
